import { render, staticRenderFns } from "./MspAttivitaSci.vue?vue&type=template&id=5455ba85"
import script from "./MspAttivitaSci.vue?vue&type=script&lang=js"
export * from "./MspAttivitaSci.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports